import React from "react";

export default function BulletSection({ heading, intro, bullets, closing }) {
  return (
    <div className="sx-container">
      <div className="sx-card">
        {heading && <h3 className="sx-heading">{heading}</h3>}

        {Array.isArray(intro) &&
          intro.map((para, idx) => (
            <p key={idx} className="sx-paragraph">
              {para}
            </p>
          ))}

        {Array.isArray(bullets) && bullets.length > 0 && (
          <ul className="sx-bullets">
            {bullets.map((b, idx) => (
              <li key={idx}>{b}</li>
            ))}
          </ul>
        )}

        {closing && (
          <p className="sx-paragraph" style={{ marginTop: 14 }}>
            {closing}
          </p>
        )}
      </div>
    </div>
  );
}
